<script>
  export let lessons = []
  export let value   = null
</script>

<style lang="scss">
  select {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 9999;
    max-width: calc(100% - #{2 * $GU});
    margin: 0;
    padding: $GU;
    color: $white;
    font-size: 1.2em;
    font-family: inherit;
    background-color: $black;
    border: none;
    border-radius: 3px;
    box-shadow: 0 0 $GU $black;
    transform: translateX(-50%) translateY(-50%);
    appearance: none;

    &:-ms-expand {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }
</style>

<select bind:value>
  <option value={null}>sélectionnez un cours ...</option>
  {#each lessons as lesson}
    <option value={lesson}>[{lesson.years}] {lesson.title}</option>
  {/each}
</select>
